import * as React from "react";
import { Highlight, themes } from "prism-react-renderer";
import clsx from "clsx";
import { useAppSelector } from "../../store/hooks";
import { CopyButtonWithApproval } from "../../pages/domain/create/copyButtonWithApproval";
import styles from "./SyntaxHighlight.module.scss";

type Language = "json" | "bash" | "yaml" | "javascript" | "typescript" | "shell";

interface Props {
  code: string;
  language: Language;
  className?: string;
  showLineNumbers?: boolean;
  fontSize?: number;
}

export const SyntaxHighlight: React.FC<Props> = ({
  code,
  language,
  className,
  showLineNumbers = false,
  fontSize,
}) => {
  const themeMode = useAppSelector((state) => state.theme.theme);

  // Map shell to bash for prism
  const prismLanguage = language === "shell" ? "bash" : language;

  return (
    <div className={clsx(styles.container, className)}>
      <Highlight theme={themeMode === "dark" ? themes.vsDark : themes.github} code={code} language={prismLanguage}>
        {({ style, tokens, getLineProps, getTokenProps }) => (
          <pre className={clsx(styles.pre, { [styles.withLineNumbers]: showLineNumbers })} style={{ ...style, fontSize }}>
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line })} className={styles.line}>
                {showLineNumbers && <span className={styles.lineNumber}>{i + 1}</span>}
                <span className={styles.lineContent}>
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token })} />
                  ))}
                </span>
              </div>
            ))}
          </pre>
        )}
      </Highlight>
      <div className={styles.copyButtonWrapper}>
        <CopyButtonWithApproval value={code} className={styles.copyButton} />
      </div>
    </div>
  );
};
